<div class="page-layout">
  <app-toast></app-toast>

  <app-sidebar></app-sidebar>

  <div class="main-area">
    <app-navbar
      pageTitle="Analytics"
      pageSubtitle="SharePoint library mix and document processing status."
    ></app-navbar>

    <div class="content">
      <div class="analytics-layout">
      <div class="overview-card">
        <div class="overview-head">
          <h3 class="chart-title">{{ chartTitle() }}</h3>
          <p class="chart-caption">{{ chartCaption() }}</p>
        </div>

        <div class="chart-body" *ngIf="!isChartLoading() && fileTypeSegments().length > 0">
          <div class="donut-column">
            <div class="donut-wrapper">
              <svg viewBox="0 0 100 100" class="donut-svg">
                <circle
                  *ngFor="let item of fileTypeSegments()"
                  cx="50" cy="50" r="35"
                  fill="none"
                  [attr.stroke]="item.color"
                  stroke-width="10"
                  [attr.stroke-dasharray]="(item.percentage * 2.199) + ' 219.9'"
                  [attr.stroke-dashoffset]="-(item.offset * 2.199)"
                  transform="rotate(-90 50 50)"
                />
              </svg>
              <div class="donut-center">
                <span class="donut-center-value">{{ chartTotal() | number }}</span>
                <span class="donut-center-label">files</span>
              </div>
            </div>
          </div>

          <div class="legend">
            <ng-container *ngFor="let item of fileTypeSegments()">
              <button
                type="button"
                class="legend-item"
                [class.active]="isGroupFilter(item.label)"
                [class.open]="item.label === 'Others' && othersExpanded()"
                [class.expandable]="item.label === 'Others' && otherTypeBreakdown().length > 0"
                (click)="onLegendClick(item.label)"
              >
                <span class="legend-dot" [style.background]="item.color"></span>
                <span class="legend-label">{{ item.label }}</span>
                <span class="legend-count">{{ item.count | number }}</span>
                <span class="legend-percent">{{ item.percentage }}%</span>
                <span class="legend-chevron" *ngIf="item.label === 'Others' && otherTypeBreakdown().length > 0">
                  <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.2">
                    <polyline points="6 9 12 15 18 9"></polyline>
                  </svg>
                </span>
              </button>

              <div class="legend-children" *ngIf="item.label === 'Others' && othersExpanded() && otherTypeBreakdown().length > 0">
                <button
                  type="button"
                  class="legend-item nested"
                  *ngFor="let other of otherTypeBreakdown()"
                  [class.active]="isExtensionFilter(other.fileType)"
                  (click)="selectOtherType(other.fileType)"
                >
                  <span class="legend-dot" [style.background]="item.color"></span>
                  <span class="legend-label">{{ other.label }}</span>
                  <span class="legend-count">{{ other.count | number }}</span>
                  <span class="legend-percent">{{ other.percentage }}%</span>
                  <span class="legend-chevron"></span>
                </button>
              </div>
            </ng-container>
          </div>
        </div>

        <div class="mix-bar" [class.has-filter]="!!typeFilter()" *ngIf="!isChartLoading() && fileTypeSegments().length > 0">
          <span
            class="mix-seg"
            *ngFor="let item of fileTypeSegments()"
            [class.active]="isGroupInvolved(item.label)"
            [style.width.%]="item.percentage"
            [style.background]="item.color"
            [title]="mixBarTitle(item)"
            (click)="onLegendClick(item.label)"
          ></span>
        </div>

        <div class="chart-loading" *ngIf="isChartLoading()">
          <div class="spinner"></div>
        </div>

        <p class="chart-empty" *ngIf="!isChartLoading() && fileTypeSegments().length === 0">
          {{ chartEmptyMessage() }}
        </p>
      </div>

      <div class="docs-panel">
        <div class="docs-toolbar">
          <div class="toolbar-start">
            <div class="toggle-group">
              <button class="toggle-btn" [class.active]="activeTab() === 'unprocessed'" (click)="setActiveTab('unprocessed')">Unprocessed</button>
              <button class="toggle-btn" [class.active]="activeTab() === 'failed'" (click)="setActiveTab('failed')">Failed</button>
              <button class="toggle-btn" [class.active]="activeTab() === 'processed'" (click)="setActiveTab('processed')">Processed</button>
            </div>
            <span class="doc-count" *ngIf="activeTab() === 'unprocessed'">
              {{ unprocessedDisplayCount() | number }} unprocessed
            </span>
            <span class="doc-count" *ngIf="activeTab() !== 'unprocessed'">
              {{ activeDocumentCount() | number }} documents
            </span>
          </div>

          <div class="toolbar-end">
            <button type="button" class="filter-chip" *ngIf="typeFilter()" (click)="clearTypeFilter()">
              <span class="filter-chip-key">Type</span>
              <span class="filter-chip-value">{{ typeFilterLabel() }}</span>
              <svg width="12" height="12" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.5">
                <line x1="18" y1="6" x2="6" y2="18"/>
                <line x1="6" y1="6" x2="18" y2="18"/>
              </svg>
            </button>
            <div class="search-box">
              <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="#68728F" stroke-width="2">
                <circle cx="11" cy="11" r="8"/>
                <line x1="21" y1="21" x2="16.65" y2="16.65"/>
              </svg>
              <input type="text" placeholder="Search..." [value]="activeSearchQuery()" (input)="onActiveSearch($event)" />
            </div>
          </div>
        </div>

        <ng-container *ngIf="activeTab() === 'unprocessed'">
          <div class="docs-body">
          <div class="loading-state" *ngIf="isLoadingUnprocessed()">
            <div class="spinner"></div>
          </div>

          <table class="doc-table" *ngIf="!isLoadingUnprocessed() && pagedItems().length > 0">
            <thead>
              <tr>
                <th>Name</th>
              </tr>
            </thead>
            <tbody>
              <tr *ngFor="let item of pagedItems()">
                <td class="col-name">
                  <span class="file-icon" [ngClass]="iconClass(item)">
                    <svg width="14" height="14" viewBox="0 0 24 24" fill="#FFFFFF">
                      <path d="M14 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V8z"/><path d="M14 2v6h6" fill="none" stroke="#FFFFFF" stroke-width="1.5"/>
                    </svg>
                  </span>
                  <span class="file-name">{{ item.name }}</span>
                  <span class="file-ext" *ngIf="showOtherTypeBadge()">{{ fileExtLabelFromName(item.name) }}</span>
                </td>
              </tr>
            </tbody>
          </table>

          <div class="empty-docs" *ngIf="!isLoadingUnprocessed() && unprocessedMatchTotal() === 0">
            <p>No unprocessed files found.</p>
          </div>
          </div>

          <div class="pagination-row" *ngIf="unprocessedMatchTotal() > 0">
            <button class="page-nav" [disabled]="isLoadingUnprocessed() || currentPage() === 1" (click)="goToPage(currentPage() - 1)">
              <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"><polyline points="15 18 9 12 15 6"></polyline></svg>
            </button>
            <ng-container *ngFor="let p of paginationItems(totalPages(), currentPage())">
              <span class="page-ellipsis" *ngIf="p === '…'">…</span>
              <button class="page-num" *ngIf="p !== '…'" [class.active]="p === currentPage()" [disabled]="isLoadingUnprocessed()" (click)="goToPage(p)">{{ p }}</button>
            </ng-container>
            <select class="page-select" [value]="currentPage()" (change)="onPageSelect($event)">
              <option *ngFor="let p of fullPageNumbers(totalPages())" [value]="p">{{ p }}</option>
            </select>
            <button class="page-nav" [disabled]="isLoadingUnprocessed() || currentPage() === totalPages()" (click)="goToPage(currentPage() + 1)">
              <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"><polyline points="9 18 15 12 9 6"></polyline></svg>
            </button>
          </div>
        </ng-container>

        <ng-container *ngIf="activeTab() === 'failed'">
          <div class="docs-body">
          <div class="loading-state" *ngIf="isLoadingFailed()">
            <div class="spinner"></div>
          </div>

          <table class="doc-table" *ngIf="!isLoadingFailed() && pagedFailed().length > 0">
            <thead>
              <tr>
                <th>Name</th>
              </tr>
            </thead>
            <tbody>
              <tr *ngFor="let doc of pagedFailed()">
                <td class="col-name">
                  <span class="file-icon" [ngClass]="docIconClass(doc)">
                    <svg width="14" height="14" viewBox="0 0 24 24" fill="#FFFFFF">
                      <path d="M14 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V8z"/><path d="M14 2v6h6" fill="none" stroke="#FFFFFF" stroke-width="1.5"/>
                    </svg>
                  </span>
                  <span class="file-name">{{ doc.fileName }}</span>
                  <span class="file-ext" *ngIf="showOtherTypeBadge()">{{ fileExtLabelFromName(doc.fileName) }}</span>
                </td>
              </tr>
            </tbody>
          </table>

          <div class="empty-docs" *ngIf="!isLoadingFailed() && pagedFailed().length === 0">
            <p>No failed documents found.</p>
          </div>
          </div>

          <div class="pagination-row" *ngIf="!isLoadingFailed() && filteredFailed().length > 0">
            <button class="page-nav" [disabled]="failedPage() === 1" (click)="goToFailedPage(failedPage() - 1)">
              <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"><polyline points="15 18 9 12 15 6"></polyline></svg>
            </button>
            <ng-container *ngFor="let p of paginationItems(totalFailedPages(), failedPage())">
              <span class="page-ellipsis" *ngIf="p === '…'">…</span>
              <button class="page-num" *ngIf="p !== '…'" [class.active]="p === failedPage()" (click)="goToFailedPage(p)">{{ p }}</button>
            </ng-container>
            <select class="page-select" [value]="failedPage()" (change)="onFailedPageSelect($event)">
              <option *ngFor="let p of fullPageNumbers(totalFailedPages())" [value]="p">{{ p }}</option>
            </select>
            <button class="page-nav" [disabled]="failedPage() === totalFailedPages()" (click)="goToFailedPage(failedPage() + 1)">
              <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"><polyline points="9 18 15 12 9 6"></polyline></svg>
            </button>
          </div>
        </ng-container>

        <ng-container *ngIf="activeTab() === 'processed'">
          <div class="docs-body">
          <div class="loading-state" *ngIf="isLoadingProcessed()">
            <div class="spinner"></div>
          </div>

          <table class="doc-table" *ngIf="!isLoadingProcessed() && pagedProcessed().length > 0">
            <thead>
              <tr>
                <th>Name</th>
              </tr>
            </thead>
            <tbody>
              <tr *ngFor="let doc of pagedProcessed()">
                <td class="col-name">
                  <span class="file-icon" [ngClass]="docIconClass(doc)">
                    <svg width="14" height="14" viewBox="0 0 24 24" fill="#FFFFFF">
                      <path d="M14 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V8z"/><path d="M14 2v6h6" fill="none" stroke="#FFFFFF" stroke-width="1.5"/>
                    </svg>
                  </span>
                  <span class="file-name">{{ doc.fileName }}</span>
                  <span class="file-ext" *ngIf="showOtherTypeBadge()">{{ fileExtLabelFromName(doc.fileName) }}</span>
                </td>
              </tr>
            </tbody>
          </table>

          <div class="empty-docs" *ngIf="!isLoadingProcessed() && pagedProcessed().length === 0">
            <p>No processed documents found.</p>
          </div>
          </div>

          <div class="pagination-row" *ngIf="!isLoadingProcessed() && filteredProcessed().length > 0">
            <button class="page-nav" [disabled]="processedPage() === 1" (click)="goToProcessedPage(processedPage() - 1)">
              <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"><polyline points="15 18 9 12 15 6"></polyline></svg>
            </button>
            <ng-container *ngFor="let p of paginationItems(totalProcessedPages(), processedPage())">
              <span class="page-ellipsis" *ngIf="p === '…'">…</span>
              <button class="page-num" *ngIf="p !== '…'" [class.active]="p === processedPage()" (click)="goToProcessedPage(p)">{{ p }}</button>
            </ng-container>
            <select class="page-select" [value]="processedPage()" (change)="onProcessedPageSelect($event)">
              <option *ngFor="let p of fullPageNumbers(totalProcessedPages())" [value]="p">{{ p }}</option>
            </select>
            <button class="page-nav" [disabled]="processedPage() === totalProcessedPages()" (click)="goToProcessedPage(processedPage() + 1)">
              <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"><polyline points="9 18 15 12 9 6"></polyline></svg>
            </button>
          </div>
        </ng-container>
      </div>
      </div>
    </div>
  </div>
</div>
